import React from 'react';

function IconPlusAccordion({ fontSize = 18 }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 18 18"
            fill="none"
            fontSize={fontSize}
        >
            <circle cx="9" cy="9" r="9" fill="#FFC30D" />
            <path
                d="M5 9H13"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M9 5L9 13"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}

export default IconPlusAccordion;
